// extracted by mini-css-extract-plugin
export default {"notFound":"Home2_notFound__ZLToG","searchResult":"Home2_searchResult__t+BVo"};